<template>
    <div class="home">
        <h5>Home</h5>
        
        <div v-if="showDashboard">
            <dashboard />
        </div>
        <div v-if="quotes && quotes.length">
            <div class="container" v-if="specials">
                <h6>Specials</h6> 
                <div class="row">
                    <quote-summary v-for="quote in specials" :key="quote.Id" 
                        :value="quote" @click.prevent="select(quote)" />
                </div>
            </div>
            <div class="container" v-if="picks">
                <h6>Picks</h6> 
                <div class="row">
                    <quote-summary v-for="quote in picks" :key="quote.Id" 
                        :value="quote" @click.prevent="select(quote)" />
                </div>
            </div>
            <div class="container" v-if="myQuotes">
                <h6>My Quotes</h6> 
                <div class="row">
                    <quote-summary v-for="quote in myQuotes" :key="quote.Id" 
                        :value="quote" @click.prevent="select(quote)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Dashboard from './Dashboard.vue';
    import QuoteSummary from './QuoteSummary.vue';
    
    export default {
        components: { 
            QuoteSummary,
            Dashboard 
        },
        name: 'Home',
        data() {
            return { 
                quotes: [],
                showDashboard: false         
            };
        },
        computed: {
            specials: function() {
                var quotes = this.quotes.filter(q => q.TypeId == this.specialQuoteTypeId && q.StatusId == this.pendingQuoteStatusId);
                return quotes.length > 0 ? quotes : null;
            },
            picks: function() {
                var quotes = this.quotes.filter(q => q.TypeId == this.pickQuoteTypeId && q.StatusId == this.pendingQuoteStatusId);
                return quotes.length > 0 ? quotes : null;
            },
            myQuotes: function() {
                var quotes = this.quotes.filter(q => q.TypeId == this.defaultQuoteTypeId && 
                    (q.StatusId == this.pendingQuoteStatusId || q.StatusId == this.acceptedQuoteStatusId));
                return quotes.length > 0 ? quotes : null;
            }
        },
        created: function () {
            //this.showDashboard = this.getPermissions("Organisation").Read;
            this.contactId = localStorage.getItem('contactId');
            this.defaultQuoteTypeId = this.getSetting('DefaultQuoteTypeId');
            this.specialQuoteTypeId = this.getSetting('SpecialQuoteTypeId');
            this.pickQuoteTypeId = this.getSetting('PickQuoteTypeId');
            this.pendingQuoteStatusId = this.getSetting('PendingQuoteStatusId');
            this.acceptedQuoteStatusId = this.getSetting('AcceptedQuoteStatusId');
          
            if(this.contactId && this.contactId > 0) {
                if(!this.showDashboard) {
                    var url = this.apiUrl + 'contacts/' + this.contactId + '/quotes';        
                    this.get(url,(data) => { this.quotes = data; });
                }
            }
        },
        mounted: function () {

        },
        methods: { 
            select(quote) {
                //console.log(quote);
                this.$router.push({ name: 'New Quote', params: { id: quote.Id } });  
            }          
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .container {
          background: #eeeeee;
          border-radius: 10px;
          margin-bottom: 10px;
    }
    .quotesummary {
        margin: 10px;
        box-shadow: 3px 3px 2px darkgrey;
    }
    .quotesummary:hover {
        cursor: pointer;
    }
    .container {
        padding: 10px;
    }

    @media (max-width: 992px) {
        .quotesummary {
            margin-left: 0px;
            margin-bottom: 0px;
        }
    }
</style>


